import * as React from 'react';
import classnames from 'classnames';
import { QuantitySelector } from '@grandvisionhq/common';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const ProductQuantitySelector = ({ quantity , minimumQuantity =1 , maximumQuantity , onDecreaseQuantity , onIncreaseQuantity , children , className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-quantity-selector', className)
    }, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-smallest",
        className: "product-quantity-selector__label"
    }, getLabel('products.detail.selectAmount')), /*#__PURE__*/ React.createElement("div", {
        className: "product-quantity-selector__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: quantity,
        minimumQuantity: minimumQuantity,
        maximumQuantity: maximumQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity
    }), children));
};

export { ProductQuantitySelector };
//# sourceMappingURL=ProductQuantitySelector.js.map
